// App.js
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import HomePage from './HomePage';
import TeamPage from './Team';
import DonatePage from './Donate';
import InitiativePage from './Initiatives';
import AboutUs from './About';

function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/team" element={<TeamPage />} />
      <Route path="/donate" element={<DonatePage />} />
      <Route path="/initiatives" element={<InitiativePage />} />
      <Route path="/about" element={<AboutUs />} />
    </Routes>
  );
}

export default App;